export const validationRules = {
  parentDepartment: { required: true, message: "Parent Department is required" },
  // deptCode: {
  //   required: true,
  //   pattern: /^\d+$/,
  //   message: "Department Assigned Code must be a number",
  // },
  deptCode: {
    required: true,
    pattern: /^[A-Za-z0-9]+$/,
    message: "Only letters and numbers are allowed.",
  },
  // aisheCode: {
  //   required: true,
  //   pattern: /^[A-Za-z0-9-]{3,20}$/,
  //   message: "Enter valid AISHE Code",
  // },
  aisheCode: {
    required: true,
    pattern: /^[A-Z]-\d{5}$/,
    message: "AISHE Code must be in format like C-12345",
  },

  instituteName: {
    required: true,
    pattern: /^[A-Za-z\s]{3,100}$/,
    message: "Institute Name should contain only letters and spaces",
  },

  creatorUserName: {
    required: true,
    pattern: /^[A-Za-z\s]+$/,
    message: "Name should contain only alphabets",
  },

  mahaDbtCode: {
    required: false,
    pattern: /^[A-Za-z0-9]+$/,
    message: "Maha DBT Code is required and must be alphanumeric",
  },



  state: { required: true, message: "State is required" },
  district: { required: true, message: "District is required" },
  taluka: { required: true, message: "Taluka is required" },
  // village: { required: true, message: "Village is required" },

  address: {
    required: true,
    pattern: /^[A-Za-z0-9\s,./\-#()&]{3,250}$/,
    message: "Please enter a valid address",
  },

  pincode: {
    required: true,
    pattern: /^[0-9]{6}$/,
    message: "Enter valid 6-digit pincode",
  },

  // website: {
  //   required: true,
  //   // allow www.example.com, http://example.com, https://example.com
  //   pattern: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}$/,
  //   message: "Enter valid website URL",
  // },
  website: {
    required: true,
    validations: [
      {
        pattern: /^https?:\/\//i,
        message: "Website must start with http:// or https://",
      },
      {
        pattern: /^https?:\/\/([A-Za-z0-9@-]+\.)+[a-zA-Z]{2,}(\/[A-Za-z0-9@\-./?%&=]*)?$/,
        message: "Please enter a valid Website (e.g., https://www.example.com)",
      },
    ],
  },

  stdCode: {
    required: true,
    pattern: /^0[0-9]{1,4}$/,
    message: "Enter valid STD code (must start with 0)",
  },

  phone: {
    required: true,
    pattern: /^[0-9]{6,8}$/,
    message: "Enter a valid number (6 to 8 digits only)",
  },

  mobileNumber: {
    required: true,
    pattern: /^[6-9]\d{9}$/,
    message: "Enter valid mobile number",
  },

  email: {
    required: true,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: "Enter valid email address",
  },

  instituteType: { required: true, message: "Institute Type is required" },
  // regNumber: { required: true, message: "Registration Number is required" },
  regNumber: {
    required: true,
    pattern: /^[A-Za-z0-9]{3,15}$/,
    message: "Enter Registration Number",
  },

  establishYear: {
    required: true,
    pattern: /^(18|19|20)\d{2}$/,
    message: "Enter valid establishment year",
  },

  university: { required: true, message: "University is required" },
  instituteUnder: { required: true, message: "Institute Under is required" },

  naacAccredited: {
    required: true,
    message: "Please select NAAC accreditation status",
  },
  aadhaarNumber: {
    required: true,
    pattern: /^(?:[2-9][0-9]{11}|[2-9][0-9]{3}(?:\\s[0-9]{4}){2}|[2-9][0-9]{3}(?:-[0-9]{4}){2})$/,
    message: "Enter a valid Aadhaar number (12 digits, should not start with 0 or 1)",
  },
};
